module.exports = __webpack_public_path__ + "img/Claim.eb1eddde.svg";